<template>
    <div class="p-admin-conf-consultation">
        <div class="card mb-3">
            <div class="card-header">決済設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <template v-if="conf.category === confCategory.payment">
                        <div v-if="conf.value_type === confValue.bool" class="m-1">
                            <div class="form-group m-form__group">
                                <label
                                    v-if="conf.is_display_name"
                                    :for="`key-${conf.key}`"
                                    class="vc-conf-name">
                                    {{ conf.name }}：
                                </label>
                                <div>
                                    <div class="form-check mb-1">
                                        <input
                                            v-model="configurations[index].value"
                                            value="1"
                                            :id="`key-${conf.key}_1`"
                                            class="form-check-input"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            type="radio">
                                        <label
                                            :for="`key-${conf.key}_1`"
                                            style="cursor:pointer;"
                                            class="form-check-label">
                                            {{ conf.label_bool_1 }}
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input
                                            v-model="configurations[index].value"
                                            value="0"
                                            :id="`key-${conf.key}_2`"
                                            class="form-check-input"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            type="radio">
                                        <label
                                            :for="`key-${conf.key}_2`"
                                            style="cursor:pointer;"
                                            class="form-check-label">
                                            {{ conf.label_bool_2 }}
                                        </label>
                                    </div>
                                </div>
                                <div v-if="errors[ `${index}.${helper.valueField(conf)}` ]" class="invalid-feedback d-block mt-1">
                                    {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                                </div>
                            </div>
                        </div>
                        <div v-else-if="conf.value_type === confValue.int" class="m-1">
                            <div class="form-group m-form__group">
                                <label
                                    v-if="conf.is_display_name"
                                    :for="`key-${conf.key}`"
                                    class="vc-conf-name">
                                    {{ conf.name }}：
                                </label>
                                <div class="d-flex align-items-center">
                                    <span
                                        v-if="conf.text_prefix !== null"
                                        class="small text-muted mr-2">
                                        {{ conf.text_prefix }}
                                    </span>
                                    <input
                                        v-model="configurations[index].value"
                                        :id="`key-${conf.key}`"
                                        class="form-control m-input vc-input-int"
                                        :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                        :disabled="confPaymentConsultationAutoCharge.value == '0'"
                                        type="text">
                                    <span
                                        v-if="conf.text_suffix !== null"
                                        class="small text-muted ml-2">
                                        {{ conf.text_suffix }}
                                    </span>
                                </div>
                                <div class="invalid-feedback d-block mt-1" v-if="errors[ `${index}.${helper.valueField(conf)}` ]">
                                    {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-if="conf.key === 'payment'">
                        <div v-for="(paymentMethod, index) in paymentMethods">
                            <div class="m-1">
                                <div class="form-group m-form__group">
                                    <label
                                        class="vc-conf-name"
                                        :for="`key-payment_method-${paymentMethod.id}`">
                                        <span>{{ paymentMethod.name }}：</span>
                                    </label>
                                    <div>
                                        <div class="form-check mb-1">
                                            <input
                                                v-model="paymentMethods[index].flg_show"
                                                value="1"
                                                :id="`key-payment_method-${paymentMethod.id}_1`"
                                                class="form-check-input"
                                                type="radio"
                                                :disabled="confPayment.value == '0'">
                                            <label
                                                :for="`key-payment_method-${paymentMethod.id}_1`"
                                                style="cursor:pointer;"
                                                class="form-check-label">
                                                表示
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input
                                                v-model="paymentMethods[index].flg_show"
                                                value="0"
                                                :id="`key-payment_method-${paymentMethod.id}_2`"
                                                class="form-check-input"
                                                type="radio"
                                                :disabled="confPayment.value == '0'">
                                            <label
                                                :for="`key-payment_method-${paymentMethod.id}_2`"
                                                style="cursor:pointer;"
                                                class="form-check-label">
                                                非表示
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </template>
                </div>
                <div
                    v-if="errors.payment_methods"
                    class="invalid-feedback d-block mb-3">
                    {{ errors.payment_methods[0] }}
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

export default {
    props: {
        conf: {
            type: Array,
            required: true,
        },
        paymentMethods: {
            type: Array,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            configurations: [],
            errors: {},
            inProgress: false,
            confCategory: constants.confCategory,
            confValue: constants.confValue,
        }
    },

    computed: {
        /**
         * 更新データ準備
         *
         * @return {object}
         */
        preparedConfigurations: function () {
            return this.helper.bindConfigurationsValue(this.configurations)
        },

        /**
         * 決済設定を取得
         *
         * @return {object}
         */
        confPayment: function () {
            return this.configurations.find(config => config.key === 'payment')
        },

        /**
         * 相談予約の自動支払設定を取得
         *
         * @return {object}
         */
        confPaymentConsultationAutoCharge: function () {
            return this.configurations.find(config => config.key === 'payment_consultation_auto_charge')
        },
    },

    methods: {
        /**
         * 設定更新
         */
        updateConfigurations: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpointMethod = constants.admin.payment_methods.endpoint.base
            const endpointConf = constants.admin.configurations.endpoint.base

            const res = await axios.put(endpointMethod, {payment_methods: this.paymentMethods, config: this.confPayment.value})
                .catch(({response}) => {
                    this.errors = response.data.errors
                    bus.$emit('alert-danger')
                    return false
                })

            if (res === false) {
                this.inProgress = false
                return
            }

            await axios.post(endpointConf, this.preparedConfigurations)
                .then(() => {
                    this.errors = {}
                    bus.$emit('alert-success', '設定を更新しました。')
                })
                .catch(({response}) => {
                    this.errors = response.data.errors
                    bus.$emit('alert-danger')
                })

            this.inProgress = false
        },
    },

    watch: {
        conf: function (conf) {
            this.configurations = conf
        },
    }
}
</script>

<style lang="scss" scoped>
.vc-conf-name {
    color: #5f5f5f;
    font-size: 13px;
    font-weight: bold;
}

.vc-input-int {
    max-width: 100px;
}
</style>
